import { isEmpty, trim } from "lodash";

export const accountName = (accountName, accountNum, nickName='') => {
  const name = String(accountName);
  const num = String(accountNum);
  
  let val = "";

  switch (name) {
    case "KEB하나은행":
      val = String(name.substring(3, 5) + `(${num.substr(num.length - 5)})`);
      break;

    default:
      val = String(name.substring(0, 2) + `(${num.substr(num.length - 5)})`);
      break;
  }

  if(!isEmpty(nickName) && trim(String(nickName)) !== "") {
    val += " - [" + trim(String(nickName)) + "]"
  }

  return val;
};

export const cardName = (cardName='', cardNum, nickName='') => {
  const name = String(cardName);
  const num = String(cardNum);

  let val = String(name.replace("카드", "") + `(${num.substr(num.length - 4)})`);

  if(!isEmpty(nickName) && trim(String(nickName)) !== "") {
    val += " - [" + trim(String(nickName)) + "]"
  }

  return val
};
